<script>
import { mapGetters } from 'vuex';
import FeaturePlaceholder from './FeaturePlaceholder.vue';
export default {
  components: { FeaturePlaceholder },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  data() {
    return { darkTheme: false, themeObserver: null };
  },
  computed: {
    ...mapGetters({ globalConfig: 'globalConfig/get' }),
    // Served from public/, so it must stay a runtime path: a literal src in the
    // template makes Vite try to resolve it as a module at build time.
    // Owner order 2026-09-21: a monochrome, restrained mark instead of the 3D
    // one - graphite on the light theme, silver on the dark theme.
    markSrc() {
      return this.darkTheme
        ? '/brand-assets/logo-mono-dark.svg'
        : '/brand-assets/logo-mono-light.svg';
    },
  },
  mounted() {
    this.readTheme();
    this.themeObserver = new MutationObserver(this.readTheme);
    this.themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'data-theme'],
    });
  },
  beforeUnmount() {
    this.themeObserver?.disconnect();
  },
  methods: {
    readTheme() {
      this.darkTheme = document.documentElement.classList.contains('dark');
    },
  },
};
</script>

<template>
  <div class="flex flex-col items-center justify-center h-full">
    <!-- Teletel: a quiet monochrome wordmark, one file per theme. -->
    <img
      class="block w-44 m-4 opacity-90"
      :src="markSrc"
      :alt="globalConfig.installationName"
    />
    <span class="text-sm font-medium text-center text-n-slate-12">
      {{ message }}
      <br />
    </span>
    <!-- Cmd bar, keyboard shortcuts placeholder -->
    <FeaturePlaceholder />
  </div>
</template>
